<div class="p-ng">
  <div [ngClass]="{ 'p-input-filled mb-0': !border, field: true }">
    <label class="block label-select-tree">
      <span *ngIf="showLabel"> {{ label | translate }}</span>
      <span
        *ngIf="checkRequire()"
        class="p-errors"
        style="color: red; margin-left: 3px"
        >*</span
      ></label
    >
    <p-treeSelect
      (onShow)="onTreePanelShow()"
      [filter]="enableSearch"
      [formControl]="control"
      [(ngModel)]="selectedNode"
      [metaKeySelection]="metaKeySelection"
      [options]="nodes"
      [selectionMode]="selectionMode"
      [placeholder]="placeholder"
      [showClear]="!readonly && showClear"
      [ngClass]="{ 'ng-invalid ng-dirty': errors, readonly: readonly }"
      [scrollHeight]="scrollHeight"
      [panelStyle]="panelStyle"
      appendTo="body"
      [propagateSelectionUp]="!isFiltering"
      [propagateSelectionDown]="!isFiltering"
      (onFilter)="onFilter($event)"
    ></p-treeSelect>

    <div class="relative b-errors">
      <ng-container *ngIf="errors">
        <small class="p-error error-msg block fadeinup animation-duration-300">
          <span class="block">{{ displayedErrorMessage }}</span>
        </small>
      </ng-container>
    </div>
  </div>
</div>
